/* eslint-disable react-hooks/rules-of-hooks */
import { ColumnDef } from '@tanstack/table-core';
// eslint-disable-next-line import/no-cycle
import { getHeaderName } from 'src/components/collapsible-table/table-column-prep';
import { Header, TableComponent } from '../../../../pricing-simulator/types/generic-table.model';
import CheckboxWithLabel from '../../../../pricing-simulator/components/table-columns/checkbox-with-label';

export default function getHeaderForCheckboxLabel(columnData: Header,  componentType: TableComponent) {

  const subHeader: ColumnDef<{
    [key: string]: number | string | { [key: string]: string }[];
  }> = {
    id:
      columnData.parent.parent_field !== ''
        ? columnData.parent.parent_field
        : columnData.parent.order.toString(),
    meta: {
      className: 'last sticky-first-col'
    },
    // eslint-disable-next-line react/no-unescaped-entities
    header: (props) =>
      columnData.children.length > 1 ? (
        <div>
          {' '}
          {columnData.parent.alias} {getHeaderName(columnData)}
        </div>
      ) : null,
    cell: ({ row }) => (
      <CheckboxWithLabel row={row} columnMetadata={columnData} componentType={componentType}/>
    )
  };
  return subHeader;
};